<template>
  <div>
    <div class="blackBG-grammar"></div>
    <!-- <h3 class="title">סיכום המשחק:</h3>
    <p>{{ msg }}</p> -->
    <div class="modal">
      <div class="played-words" v-if="results">
        <div v-if="results" class="backBtn" @click="results = false">
          <inline-svg
            class="cup-svg saveWord"
            :src="require('../../assets/svg/back.svg').default"
          ></inline-svg>
        </div>
        <div>{{ $t("grammarGame.game-summery.improve") }}</div>
        <!-- <div class="divMistakes">שגיאות</div> -->
        <div v-if="mistakes.length">
          <div class="gmistakes-header">
            <div class="wbold g-head">
              {{ $t("grammarGame.game-summery.question") }}
            </div>
            <div></div>
            <div class="wbold">{{ $t("grammarGame.game-summery.answer") }}</div>
            <div class="wbold">
              {{ $t("grammarGame.game-summery.mistake") }}
            </div>
          </div>

          <div class="gmistakes" v-for="(word, idx) in mistakes" :key="idx">
            <div class="audio"><AudioBtn :urlId="word.word.id" /></div>
            <div class="g-q">{{ word.word.eng }}</div>
            <div class="g-a arial">{{ word.word.heb }}</div>
            <div class="g-m">{{ word.mistake }}</div>
          </div>
        </div>
        <div v-if="!mistakes.length" class="divMistakes" :style="{ textAlign: ltr ? 'left' : 'right' }" >
          {{ $t("grammarGame.game-summery.perfect") }}
        </div>
      </div>
      <div v-if="!results">
        <div class="description">{{ outText }}</div>
        <Spacer height="12" v-if="audioSrc" />
        <AudioPlayer
          v-if="audioSrc"
          :audioSrc="audioSrc"
          :autoPlay="isAutoPlay"
        />
        <Spacer height="12" v-if="vidSrc" />
        <VideoPlayer1 :vidSrc="makeLinkEmbaddable(vidSrc)" v-if="vidSrc" />
        <Spacer height="12" v-if="imgSrc" />
        <img v-if="imgSrc" id="img" :src="imgSrc" />
        <Spacer height="12" />
      </div>
      <div class="flex btnsDiv" v-if="!results">
        <button class="btnSummry btnRestart" @click="restartGame">
          {{ $t("grammarGame.game-summery.again") }}
        </button>
        <button class="btnSummry btnRes" @click="results = true">
          {{ $t("grammarGame.game-summery.results") }}
        </button>
      </div>
      <button v-if="!results" class="btnSummry btnGo" @click="goBack">
        {{ $t("grammarGame.game-summery.continue") }}
      </button>
    </div>
  </div>
</template>

<script>
import "./game-summary.scss";
import AudioBtn from "../Shared/audioBtn.vue";
import AudioPlayer from "../Shared/AudioPlayer.vue";
import VideoPlayer from "../Shared/VideoPlayer.vue";
import { userService } from "../../services/userService";

import VideoPlayer1 from "../Shared/VideoPlayer.vue";
import Spacer from "../Shared/Spacer.vue";
import { courseService } from "../../services/courseService";
export default {
  name: "game-summary",
  props: {
    playedItems: {
      type: Array,
      default: () => []
    },
    msg: {
      type: String,
      //   default: this.$t("grammarGame.game-summery.next")
      default: "עברו על המילים כדי להצליח בפעם הבאה"
    },
    mistakes: {
      type: Array,
      default: () => []
    },
    currentData: {
      type: Object,
      default: () => {}
    },
    externalData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      audioSrc: null,
      vidSrc: null,
      imgSrc: null,
      outText: null,
      results: false,
      isAutoPlay: true,
      exData: null,
      allTranslationsHeight: [],
      ltr: localStorage.getItem("srcDirection") == "ltr",
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  watch: {
    currentData() {
      if (this.currentData.game.outro_image)
        this.imgSrc = this.currentData.game.outro_image;
      if (this.currentData.game.outro_audio)
        this.audioSrc = this.currentData.game.outro_audio;
      if (this.currentData.game.outro_video)
        this.vidSrc = this.currentData.game.outro_video;
      if (this.currentData.game.outro_text)
        this.outText = this.currentData.game.outro_text;
    },
    exData() {
      if (this.exData.outro_image) this.imgSrc = this.exData.outro_image;
      if (this.exData.outro_audio) this.audioSrc = this.exData.outro_audio;
      if (this.exData.outro_video) this.vidSrc = this.exData.outro_video;
      if (this.exData.outro_text) this.outText = this.exData.outro_text;
    },
    results() {
      this.isAutoPlay = false;
    }
  },
  methods: {
    restartGame() {
      this.$emit("restartGame");
    },
    async goBack() {
      // let thisLessonId = this.$store.getters.nextLesson.id
      // if (thisLessonId) {
      //   await userService.finishLesson(thisLessonId, this.user);
      // }

      this.$router.push("/chapter/");
    },
    goNext() {
      this.$router.push(`/lesson/${this.$store.getters.nextLesson.id}`);
      // this.results = false;
    },
    makeLinkEmbaddable: link => {
      if (String(link).includes("shorts")) {
        const youtubeID = String(link).split("/shorts/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      if (String(link).includes(".be/")) {
        const youtubeID = String(link).split(".be/")[1];
        return (
          "https://www.youtube.com/embed/" +
          youtubeID +
          "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0"
        );
      }
      const youtubeID = String(link).split("watch?v=")[1];
      return (
        "https://www.youtube.com/embed/" +
        youtubeID +
        "?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
      );
    }
  },
  async mounted() {
    if (this.externalData)
      this.exData = await courseService.getGame(this.externalData.id);
    if (this.currentData) {
      if (this.currentData.game.outro_image)
        this.imgSrc = this.currentData.game.outro_image;
      if (this.currentData.game.outro_audio)
        this.audioSrc = this.currentData.game.outro_audio;
      if (this.currentData.game.outro_video)
        this.vidSrc = this.currentData.game.outro_video;
      if (this.currentData.game.outro_text)
        this.outText = this.currentData.game.outro_text;
    }
  },
  components: {
    AudioBtn,
    AudioPlayer,
    VideoPlayer,
    VideoPlayer1,
    Spacer
  }
};
</script>

<style scoped>
button {
  border: none;
}
.progress-icon {
  height: 24px;
}
.translations {
  font: var(--medium-font);
  display: flex;
  flex-direction: column;
  width: 55%;
  text-align: center;
}
.gmistakes-header {
  border-bottom: 1px solid var(--color-primary);
  display: flex;
  height: 74px;
  align-items: center;
  justify-content: space-between;
  margin: 0 10px;
}
.gmistakes {
  border-bottom: 1px solid var(--color-primary);
  display: flex;
  height: fit-content;
  align-items: center;
  justify-content: space-between;
  margin: 0 10px;
}

.idx {
  margin: 0 12px;
  width: 0.5em;
}
.audio {
  margin-right: 6px;
  /* width: 2em; */
}
.played-words {
  margin-top: 20px;
  font: var(--medium-font);
  width: 100%;
  margin-bottom: 10px;
}
.saveWord {
  fill: var(--button-primary-text);
}
.blackBG-grammar {
  background-color: var(--color-primary);
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  z-index: 11;
  background-color: var(--bg-primary);
  opacity: 1;
  padding: 12px;
  border-radius: 4px;
  max-width: 80vw;
  transform: translate(-50%, -50%);
  position: absolute;
  top: 50%;
}
.backBtn {
  margin-bottom: 20px;
}
.wbold {
  font-weight: 700;
  text-decoration: underline;
}
.g-q {
  color: var(--game-button-primary);
  width: 30%;
}
.g-a {
  color: var(--button-primary);
  width: 30%;
}
.g-m {
  color: var(--error-primary);
  width: 30%;
}
.g-head {
  width: 40%;
}

.btnSummry {
  border-radius: 6px;
  width: 100%;
  font: var(--medium-font);
}
.btnRestart {
  color: var(--game-button-primary);
  background-color: var(--bubble-primary);
}
.btnGo {
  color: var(--button-primary);
  background-color: var(--button-primary);
  margin-top: 8px;
  height: 60px;
}
.btnRes {
  color: var(--color-primary);
  background-color: var(--button-restart-primary);
}
.btnsDiv {
  gap: 5px;
  width: 100%;
  height: 50px;
}
.divMistakes {
  font: var(--medium-font);
}
.description {
  font: var(--huge-font);
}
</style>



// WEBPACK FOOTER //
// game-summary.vue?3c04eef4